import { format } from 'date-fns';

/**
 * 必要に応じてフォーマットを追加する
 */
type FormatType =
  | 'yyyy/M/d'
  | 'yyyy/M/d H:mm'
  | 'yyyy/MM/dd'
  | 'yyyy/MM/dd H:mm'
  | 'yyyy/MM/dd HH:mm'
  | 'yyyy/MM/dd HH:mm:ss'
  | 'yyyy年M月'
  | 'yyyy年M月d日'
  | 'yyyy-MM'
  | 'yyyy-MM-dd'
  | "yyyy-MM-dd'T'HH:mm:ssxxx";
type IFormatDate = (args: { date: Date; formatType: FormatType }) => string;

export const formatDate: IFormatDate = ({ date, formatType }) => format(date, formatType);
